import React, { useState, useEffect, useContext } from "react";
import { Button, Card, Form, Row, Col } from "react-bootstrap";
import { AuthContext } from "../context/AuthContext";
import SuccessModal from "../components/modals/SuccessModal";
import "../styles/CodeGenerationSettings.css";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

export default function CodeGenerationSettings() {
  const [settings, setSettings] = useState({
    itemCode: {
      includeDate: false,
      dateFormat: "YYYYMMDD",
      includeCompanyCode: false,
      includeRandomNumber: false,
      randomDigits: 4,
      includeIndexing: false,
      indexingDigits: 4,
      indexingStartNumber: 1,
      includeVariantID: false,
      includeTimeStamp: false,
      includeCustomizedText: false,
      customizedText: "",
      separator: "-",
      order: [
        "date",
        "company",
        "random",
        "indexing",
        "variantid",
        "customized",
      ],
    },
    product_number: {
      includeDate: false,
      dateFormat: "YYYYMMDD",
      includeCompanyCode: false,
      includeRandomNumber: false,
      randomDigits: 4,
      includeIndexing: false,
      indexingDigits: 4,
      indexingStartNumber: 1,
      includeVariantID: false,
      includeTimeStamp: false,
      includeCustomizedText: false,
      customizedText: "",
      separator: "-",
      manually_add: false,
      order: [
        "date",
        "company",
        "random",
        "indexing",
        "variantid",
        "customized",
      ],
    },
    poNumber: {
      includeDate: false,
      dateFormat: "YYYYMMDD",
      includeCompanyCode: false,
      includeRandomNumber: false,
      randomDigits: 4,
      includeIndexing: false,
      indexingDigits: 4,
      indexingStartNumber: 1,
      includeTimeStamp: false,
      includeSupplierID: false,
      includeCustomizedText: false,
      customizedText: "",
      separator: "-",
      order: [
        "date",
        "company",
        "random",
        "indexing",
        "supplierid",
        "customized",
      ],
    },
    orderNumber: {
      includeDate: false,
      dateFormat: "YYYYMMDD",
      includeCompanyCode: false,
      includeRandomNumber: false,
      randomDigits: 4,
      includeIndexing: false,
      indexingDigits: 4,
      indexingStartNumber: 1,
      includeTimeStamp: false,
      includeCustomerID: false,
      includeCustomizedText: false,
      customizedText: "",
      separator: "-",
      order: [
        "date",
        "company",
        "random",
        "indexing",
        "customerid",
        "customized",
      ],
    },
    grnNumber: {
      includeDate: false,
      dateFormat: "YYYYMMDD",
      includeCompanyCode: false,
      includeRandomNumber: false,
      randomDigits: 4,
      includeIndexing: false,
      indexingDigits: 4,
      indexingStartNumber: 1,
      includeTimeStamp: false,
      includeCustomizedText: false,
      customizedText: "",
      separator: "-",
      order: [
        "date",
        "company",
        "random",
        "indexing",
        "supplierid",
        "variantid",
        "customerid",
        "customized",
      ],
    },
    gtnNumber: {
      includeDate: false,
      dateFormat: "YYYYMMDD",
      includeCompanyCode: false,
      includeRandomNumber: false,
      randomDigits: 4,
      includeIndexing: false,
      indexingDigits: 4,
      indexingStartNumber: 1,
      includeTimeStamp: false,
      includeCustomizedText: false,
      customizedText: "",
      separator: "-",
      order: [
        "date",
        "company",
        "random",
        "indexing",
        "supplierid",
        "variantid",
        "customerid",
        "customized",
      ],
    },
    lotNumber: {
      includeDate: false,
      dateFormat: "YYYYMMDD",
      includeCompanyCode: false,
      includeRandomNumber: false,
      randomDigits: 4,
      includeIndexing: false,
      indexingDigits: 4,
      indexingStartNumber: 1,
      includeTimeStamp: false,
      includeCustomizedText: false,
      customizedText: "",
      separator: "-",
      order: [
        "date",
        "company",
        "random",
        "indexing",
        "supplierid",
        "variantid",
        "customerid",
        "customized",
      ],
    },
    customerNumber: {
      includeDate: false,
      dateFormat: "YYYYMMDD",
      includeCompanyCode: false,
      includeRandomNumber: false,
      randomDigits: 4,
      includeIndexing: false,
      indexingDigits: 4,
      indexingStartNumber: 1,
      includeTimeStamp: false,
      includeCustomizedText: false,
      customizedText: "",
      separator: "-",
      order: [
        "date",
        "company",
        "random",
        "indexing",
        "supplierid",
        "variantid",
        "customerid",
        "customized",
      ],
    },
    salesNumber: {
      includeDate: false,
      dateFormat: "YYYYMMDD",
      includeCompanyCode: false,
      includeRandomNumber: false,
      randomDigits: 4,
      includeIndexing: false,
      indexingDigits: 4,
      indexingStartNumber: 1,
      includeTimeStamp: false,
      includeCustomizedText: false,
      customizedText: "",
      separator: "-",
      order: [
        "date",
        "company",
        "random",
        "indexing",
        "supplierid",
        "variantid",
        "customerid",
        "customized",
      ],
    },
    returnNumber: {
      includeDate: false,
      dateFormat: "YYYYMMDD",
      includeCompanyCode: false,
      includeRandomNumber: false,
      randomDigits: 4,
      includeIndexing: false,
      indexingDigits: 4,
      indexingStartNumber: 1,
      includeTimeStamp: false,
      includeCustomizedText: false,
      customizedText: "",
      separator: "-",
      order: [
        "date",
        "company",
        "random",
        "indexing",
        "supplierid",
        "variantid",
        "customerid",
        "customized",
      ],
    },
     // sku: {
    //   includeDate: false,
    //   dateFormat: "YYYYMMDD",
    //   includeCompanyCode: false,
    //   includeRandomNumber: false,
    //   randomDigits: 4,
    //   includeIndexing: false,
    //   includeCustomizedText: false,
    //   customizedText: "",
    //   separator: "-",
    //   order: ["date", "company", "random", "indexing", "customized"],
    // },
    // plantCode: {
    //   includeDate: false,
    //   dateFormat: "YYYYMMDD",
    //   includeCompanyCode: false,
    //   includeRandomNumber: false,
    //   randomDigits: 4,
    //   includeIndexing: false,
    //   includeCustomizedText: false,
    //   customizedText: "",
    //   separator: "-",
    //   order: ["date", "company", "random", "indexing", "customized"],
    // },
    // plantManagerCode: {
    //   includeDate: false,
    //   dateFormat: "YYYYMMDD",
    //   includeCompanyCode: false,
    //   includeRandomNumber: false,
    //   randomDigits: 4,
    //   includeIndexing: false,
    //   includeCustomizedText: false,
    //   customizedText: "",
    //   separator: "-",
    //   order: ["date", "company", "random", "indexing", "customized"],
    // },
  });

  const [draggedItem, setDraggedItem] = useState(null);
  const [companyCode, setCompanyCode] = useState("");
  const [loadingStates, setLoadingStates] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [modalVariant, setModalVariant] = useState("success");
  const [savedSettings, setSavedSettings] = useState({});
  const { userData } = useContext(AuthContext);

  // Get company code from logged-in user
  useEffect(() => {
    if (userData && userData.company_code) {
      setCompanyCode(userData.company_code);
      fetchAllSettings(userData.company_code);
    }
  }, [userData]);

  // Fetch all code generation settings from backend
  const fetchAllSettings = async (company_code) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(
        `${BASE_URL}/api/admin/code-generation-settings/get-settings?company_code=${company_code}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      if (data.success && Array.isArray(data.settings)) {
        // Transform backend data to component state format
        const newSettings = { ...settings };
        data.settings.forEach((dbSetting) => {
          if (newSettings[dbSetting.code_type]) {
            newSettings[dbSetting.code_type] = {
              includeDate: Boolean(dbSetting.include_date),
              dateFormat: dbSetting.date_format || "YYYYMMDD",
              includeCompanyCode: Boolean(dbSetting.include_company_code),
              includeRandomNumber: Boolean(dbSetting.include_random_number),
              randomDigits: dbSetting.random_digits || 4,
              includeIndexing: Boolean(dbSetting.include_indexing),
              indexingDigits: dbSetting.indexing_digits || 4,
              indexingStartNumber: dbSetting.indexing_start_number || 1,
              includeTimeStamp: Boolean(dbSetting.include_timestamp),
              includeSupplierID: Boolean(dbSetting.include_supplier_id),
              includeCustomerID: Boolean(dbSetting.include_customer_id),
              includeVariantID: Boolean(dbSetting.include_variant_id),
              includeCustomizedText: Boolean(dbSetting.include_customized_text),
              customizedText: dbSetting.customized_text || "",
              separator: dbSetting.code_separator || "-",
              manually_add: Boolean(dbSetting.manually_add) || false,
              order:
                dbSetting.order_items &&
                Array.isArray(dbSetting.order_items) &&
                dbSetting.order_items.length > 0
                  ? dbSetting.order_items
                      .sort(
                        (a, b) =>
                          (a.order_position || 0) - (b.order_position || 0),
                      )
                      .map((item) => item.component_name)
                  : ["date", "company", "random", "indexing", "customized"],
            };
          }
        });
        setSettings(newSettings);
        setSavedSettings(JSON.parse(JSON.stringify(newSettings)));
      }
    } catch (error) {
      console.error("Error fetching code generation settings:", error);
    }
  };

  const codeTypes = [
    { id: "itemCode", label: "Item Code" },
    { id: "product_number", label: "Product Number" },
    { id: "poNumber", label: "PO Number" },
    { id: "orderNumber", label: "Order Number" },
    { id: "grnNumber", label: "GRN Number" },
    { id: "gtnNumber", label: "GTN Number" },
    { id: "lotNumber", label: "Lot Number" },
    { id: "customerNumber", label: "Customer Number" },
    { id: "salesNumber", label: "Sales Number" },
    { id: "returnNumber", label: "Return Number" },
    // { id: "sku", label: "SKU" },
    // { id: "locationCode", label: "Location Code" },
    // { id: "plantCode", label: "Plant Code" },
    // { id: "plantManagerCode", label: "Plant Manager Code" },
  ];

  const dateFormats = [
    { value: "YYYYMMDD", label: "YYYYMMDD (20260310)" },
    { value: "YYYYMMDDHHmm", label: "YYYYMMDDHHmm (202603101530)" },
    { value: "YYYYMMDDHHmmss", label: "YYYYMMDDHHmmss (20260310153045)" },
    { value: "YYMMDD", label: "YYMMDD (260310)" },
    { value: "YYMMDDHHmm", label: "YYMMDDHHmm (2603101530)" },
    { value: "YYMMDDHHmmss", label: "YYMMDDHHmmss (260310153045)" },
    { value: "DDMMYY", label: "DDMMYY (100326)" },
    { value: "DDMMYYYY", label: "DDMMYYYY (10032026)" },
    { value: "DDMMYYYYHHmm", label: "DDMMYYYYHHmm (100320261530)" },
    { value: "DDMMYYYYHHmmss", label: "DDMMYYYYHHmmss (10032026153045)" },
    { value: "MMDD", label: "MMDD (0310)" },
    { value: "MMDDHHmm", label: "MMDDHHmm (03101530)" },
    { value: "MMDDHHmmss", label: "MMDDHHmmss (0310153045)" },
      // { value: "YYYY/MM/DD", label: "YYYY/MM/DD (2026/03/10)" },
      // { value: "YYYY/MM/DD HH:mm", label: "YYYY/MM/DD HH:mm (2026/03/10 15:30)" },
      // { value: "YYYY/MM/DD HH:mm:ss", label: "YYYY/MM/DD HH:mm:ss (2026/03/10 15:30:45)" },
      // { value: "YY/MM/DD", label: "YY/MM/DD (26/03/10)" },
      // { value: "YY/MM/DD HH:mm", label: "YY/MM/DD HH:mm (26/03/10 15:30)" },
      // { value: "YY/MM/DD HH:mm:ss", label: "YY/MM/DD HH:mm:ss (26/03/10 15:30:45)" },
      // { value: "DD/MM/YYYY", label: "DD/MM/YYYY (10/03/2026)" },
      // { value: "DD/MM/YYYY HH:mm", label: "DD/MM/YYYY HH:mm (10/03/2026 15:30)" },
      // { value: "DD/MM/YYYY HH:mm:ss", label: "DD/MM/YYYY HH:mm:ss (10/03/2026 15:30:45)" },
      // { value: "MM/DD", label: "MM/DD (03/10)" },
      // { value: "MM/DD HH:mm", label: "MM/DD HH:mm (03/10 15:30)" },
      // { value: "MM/DD HH:mm:ss", label: "MM/DD HH:mm:ss (03/10 15:30:45)" },
  ];

  const separators = [
    { value: "", label: "None (No separator)" },
    { value: "-", label: "Hyphen (-)" },
    { value: "_", label: "Underscore (_)" },
    { value: ".", label: "Dot (.)" },
  ];

  const componentLabels = {
    date: "Date",
    company: "Company Code",
    random: "Random Number",
    indexing: "Indexing",
    customized: "Customized Text",
    supplierid: "Supplier ID",
    variantid: "Variant ID",
    customerid: "Customer ID",
  };

  const handleToggle = (codeType, field) => {
    setSettings({
      ...settings,
      [codeType]: {
        ...settings[codeType],
        [field]: !settings[codeType][field],
      },
    });
  };

  const handleSelectChange = (codeType, field, value) => {
    setSettings({
      ...settings,
      [codeType]: {
        ...settings[codeType],
        [field]: value,
      },
    });
  };

  const handleTextChange = (codeType, value) => {
    // Limit input to maximum 5 characters
    const limitedValue = value.slice(0, 5);
    setSettings({
      ...settings,
      [codeType]: {
        ...settings[codeType],
        customizedText: limitedValue,
      },
    });
  };

  const getSelectedItems = (codeType) => {
    const config = settings[codeType];
    const selected = [];

    // Use the order from state
    config.order.forEach((item) => {
      if (item === "date" && config.includeDate) selected.push("date");
      else if (item === "company" && config.includeCompanyCode)
        selected.push("company");
      else if (item === "random" && config.includeRandomNumber)
        selected.push("random");
      else if (item === "indexing" && config.includeIndexing)
        selected.push("indexing");
      else if (item === "supplierid" && config.includeSupplierID)
        selected.push("supplierid");
      else if (item === "variantid" && config.includeVariantID)
        selected.push("variantid");
      else if (item === "customerid" && config.includeCustomerID)
        selected.push("customerid");
      else if (item === "customized" && config.includeCustomizedText)
        selected.push("customized");
    });

    return selected;
  };

  const handleDragStart = (e, item) => {
    setDraggedItem(item);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };

  const handleDrop = (e, targetItem, codeType) => {
    e.preventDefault();

    if (!draggedItem || draggedItem === targetItem) return;

    const currentOrder = [...settings[codeType].order];

    const fromIndex = currentOrder.indexOf(draggedItem);
    const toIndex = currentOrder.indexOf(targetItem);

    const updatedOrder = [...currentOrder];
    const [moved] = updatedOrder.splice(fromIndex, 1);
    updatedOrder.splice(toIndex, 0, moved);

    setSettings({
      ...settings,
      [codeType]: {
        ...settings[codeType],
        order: updatedOrder,
      },
    });

    setDraggedItem(null);
  };

  // Save settings to backend
  const handleSaveSettings = async (codeType) => {
    try {
      setLoadingStates((prev) => ({ ...prev, [codeType]: true }));
      const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";
      const token = localStorage.getItem("authToken");
      const config = settings[codeType];

      const response = await fetch(
        `${BASE_URL}/api/admin/code-generation-settings`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            company_code: companyCode,
            code_type: codeType,
            include_date: config.includeDate,
            date_format: config.dateFormat,
            include_company_code: config.includeCompanyCode,
            include_random_number: config.includeRandomNumber,
            random_digits: config.randomDigits,
            include_indexing: config.includeIndexing,
            indexing_digits: config.indexingDigits,
            indexing_start_number: config.indexingStartNumber,
            include_timestamp: config.includeTimeStamp || false,
            include_supplier_id: config.includeSupplierID || false,
            include_customer_id: config.includeCustomerID || false,
            include_variant_id: config.includeVariantID || false,
            include_customized_text: config.includeCustomizedText,
            customized_text: config.customizedText,
            code_separator: config.separator,
            manually_add: config.manually_add || false,
            order_items: config.order,
          }),
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (data.success) {
        setModalTitle("Success");
        setModalMessage(`${codeType} settings saved successfully!`);
        setModalVariant("success");
        setModalShow(true);
        // Update saved settings to reflect current settings
        setSavedSettings((prev) => ({
          ...prev,
          [codeType]: JSON.parse(JSON.stringify(settings[codeType])),
        }));
      } else {
        setModalTitle("Error");
        setModalMessage("Failed to save settings");
        setModalVariant("error");
        setModalShow(true);
      }
    } catch (error) {
      setModalTitle("Error");
      setModalMessage("Error saving settings: " + error.message);
      setModalVariant("error");
      setModalShow(true);
    } finally {
      setLoadingStates((prev) => ({ ...prev, [codeType]: false }));
    }
  };

  const generatePreview = (codeType) => {
    const config = settings[codeType];
    const selectedItems = getSelectedItems(codeType);
    const parts = [];

    selectedItems.forEach((item) => {
      switch (item) {
        case "date":
          const dateExamples = {
            YYYYMMDD: "20260310",
            YYYYMMDDHHmm: "202603101530",
            YYYYMMDDHHmmss: "20260310153045",
            YYMMDD: "260310",
            YYMMDDHHmm: "2603101530",
            YYMMDDHHmmss: "260310153045",
            DDMMYY: "100326",
            DDMMYYYY: "10032026",
            DDMMYYYYHHmm: "100320261530",
            DDMMYYYYHHmmss: "10032026153045",
            MMDD: "0310",
            MMDDHHmm: "03101530",
            MMDDHHmmss: "0310153045",
             // "YYYY/MM/DD": "2026/03/10",
            // "YYYY/MM/DD HH:mm": "2026/03/10 15:30",
            // "YYYY/MM/DD HH:mm:ss": "2026/03/10 15:30:45",
            // "YY/MM/DD": "26/03/10",
            // "YY/MM/DD HH:mm": "26/03/10 15:30",
            // "YY/MM/DD HH:mm:ss": "26/03/10 15:30:45",
            // "DD/MM/YYYY": "10/03/2026",
            // "DD/MM/YYYY HH:mm": "10/03/2026 15:30",
            // "DD/MM/YYYY HH:mm:ss": "10/03/2026 15:30:45",
            // "MM/DD": "03/10",
            // "MM/DD HH:mm": "03/10 15:30",
            // "MM/DD HH:mm:ss": "03/10 15:30:45",
          };
          parts.push(dateExamples[config.dateFormat]);
          break;
        case "company":
          parts.push(companyCode);
          break;
        case "random":
          const maxRandom = Math.pow(10, config.randomDigits);
          const randomNum = Math.floor(Math.random() * maxRandom)
            .toString()
            .padStart(config.randomDigits, "0");
          parts.push(randomNum);
          break;
        case "indexing":
          const indexNum = (config.indexingStartNumber || 1)
            .toString()
            .padStart(config.indexingDigits || 4, "0");
          parts.push(indexNum);
          break;
        case "customized":
          parts.push(config.customizedText);
          break;
        case "supplierid":
          parts.push("01");
          break;
        case "variantid":
          parts.push("01");
          break;
        case "customerid":
          parts.push("01");
          break;
        default:
          break;
      }
    });

    // Add IDs that are enabled but not in order
    if (config.includeSupplierID && !config.order.includes("supplierid")) {
      parts.push("01");
    }
    if (config.includeVariantID && !config.order.includes("variantid")) {
      parts.push("01");
    }
    if (config.includeCustomerID && !config.order.includes("customerid")) {
      parts.push("01");
    }

    return parts.length > 0
      ? parts.join(config.separator)
      : "Add options to generate preview";
  };

  const getSettingsSummary = (codeType) => {
    const config = settings[codeType];
    const summary = [];

    if (config.includeDate) {
      const dateFormatLabel =
        dateFormats.find((f) => f.value === config.dateFormat)?.label ||
        config.dateFormat;
      summary.push(`Date (${dateFormatLabel})`);
    }
    if (config.includeCompanyCode) summary.push("Company Code");
    if (config.includeRandomNumber)
      summary.push(`Random (${config.randomDigits} digits)`);
    if (config.includeIndexing) {
      const padStart = (config.indexingStartNumber || 1).toString().padStart(config.indexingDigits || 4, "0");
      const padStart2 = ((config.indexingStartNumber || 1) + 1).toString().padStart(config.indexingDigits || 4, "0");
      summary.push(`Indexing (${padStart}, ${padStart2}, ...)`);
    }
    if (config.includeCustomizedText)
      summary.push(`Custom Text ("${config.customizedText || "N/A"}")`);

    if (summary.length === 0) return "No components enabled";
    return summary.join(" → ");
  };

  const getSelectedItemsFromConfig = (config) => {
    const selected = [];
    config.order.forEach((item) => {
      if (item === "date" && config.includeDate) selected.push("date");
      else if (item === "company" && config.includeCompanyCode)
        selected.push("company");
      else if (item === "random" && config.includeRandomNumber)
        selected.push("random");
      else if (item === "indexing" && config.includeIndexing)
        selected.push("indexing");
      else if (item === "supplierid" && config.includeSupplierID)
        selected.push("supplierid");
      else if (item === "variantid" && config.includeVariantID)
        selected.push("variantid");
      else if (item === "customerid" && config.includeCustomerID)
        selected.push("customerid");
      else if (item === "customized" && config.includeCustomizedText)
        selected.push("customized");
    });
    return selected;
  };

  const generatePreviewFromConfig = (config) => {
    const selectedItems = getSelectedItemsFromConfig(config);
    const parts = [];

    selectedItems.forEach((item) => {
      switch (item) {
        case "date":
          const dateExamples = {
            YYYYMMDD: "20260310",
            YYYYMMDDHHmm: "202603101530",
            YYYYMMDDHHmmss: "20260310153045",
            YYMMDD: "260310",
            YYMMDDHHmm: "2603101530",
            YYMMDDHHmmss: "260310153045",
            DDMMYY: "100326",
            DDMMYYYY: "10032026",
            DDMMYYYYHHmm: "100320261530",
            DDMMYYYYHHmmss: "10032026153045",
            MMDD: "0310",
            MMDDHHmm: "03101530",
            MMDDHHmmss: "0310153045",
            // "YYYY/MM/DD": "2026/03/10",
            // "YYYY/MM/DD HH:mm": "2026/03/10 15:30",
            // "YYYY/MM/DD HH:mm:ss": "2026/03/10 15:30:45",
            // "YY/MM/DD": "26/03/10",
            // "YY/MM/DD HH:mm": "26/03/10 15:30",
            // "YY/MM/DD HH:mm:ss": "26/03/10 15:30:45",
            // "DD/MM/YYYY": "10/03/2026",
            // "DD/MM/YYYY HH:mm": "10/03/2026 15:30",
            // "DD/MM/YYYY HH:mm:ss": "10/03/2026 15:30:45",
            // "MM/DD": "03/10",
            // "MM/DD HH:mm": "03/10 15:30",
            // "MM/DD HH:mm:ss": "03/10 15:30:45",
          };
          parts.push(dateExamples[config.dateFormat]);
          break;
        case "company":
          parts.push(companyCode);
          break;
        case "random":
          const maxRandom = Math.pow(10, config.randomDigits);
          const randomNum = Math.floor(Math.random() * maxRandom)
            .toString()
            .padStart(config.randomDigits, "0");
          parts.push(randomNum);
          break;
        case "indexing":
          const indexNum = (config.indexingStartNumber || 1)
            .toString()
            .padStart(config.indexingDigits || 4, "0");
          parts.push(indexNum);
          break;
        case "customized":
          parts.push(config.customizedText);
          break;
        case "supplierid":
          parts.push("01");
          break;
        case "variantid":
          parts.push("01");
          break;
        case "customerid":
          parts.push("01");
          break;
        default:
          break;
      }
    });

    // Add IDs that are enabled but not in order
    if (config.includeSupplierID && !config.order.includes("supplierid")) {
      parts.push("01");
    }
    if (config.includeVariantID && !config.order.includes("variantid")) {
      parts.push("01");
    }
    if (config.includeCustomerID && !config.order.includes("customerid")) {
      parts.push("01");
    }

    return parts.length > 0 ? parts.join(config.separator) : "(No preview)";
  };

  const OrderBox = ({ item, codeType }) => (
    <div
      className="order-box selected"
      draggable
      onDragStart={(e) => handleDragStart(e, item)}
      onDragOver={handleDragOver}
      onDrop={(e) => handleDrop(e, item, codeType)}
    >
      {componentLabels[item]}
    </div>
  );

  return (
    <div className="fluid-container">
      <div className="style-header">
        <h1>Code Generation Settings</h1>
      </div>

      <Row>
        {codeTypes.map((codeType) => {
          const selectedItems = getSelectedItems(codeType.id);

        return (
          <Col key={codeType.id} md={4} className="code-type-col">
            <Card
              className="code-config-card"
              style={{
                borderRadius: "16px",
                border: "1px solid #e8eaed",
                overflow: "hidden",
                boxShadow:
                  "0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.04)",
                transition: "box-shadow 0.2s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.boxShadow =
                  "0 4px 20px rgba(0,0,0,0.10)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.boxShadow =
                  "0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.04)")
              }
            >
              {/* ── Header ── */}
              <Card.Header
                className="code-type-header"
                style={{
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%);",
                  borderBottom: "1px solid #f0f2f5",
                  padding: "16px 20px 14px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <div />
                <span
                  style={{
                    fontWeight: 600,
                    fontSize: "1rem",
                    color: "#ffffff",
                    letterSpacing: "0.3px",
                  }}
                >
                  {codeType.label}
                </span>
              </Card.Header>
              
              <Card.Body style={{ padding: "18px 20px 20px" }}>
                {/* Manual Add Option for Product Number */}
                {codeType.id === "product_number" && (
                  <div
                    style={{
                      paddingTop: "6px",
                      paddingLeft: "8px",
                      background: "#c7e492",
                      borderRadius: "10px",
                      padding: "6px",
                      borderBottom: "1.5px solid #afd5d8",
                    }}
                  >
                    <label
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <Form.Check
                        type="checkbox"
                        checked={settings[codeType.id].manually_add || false}
                        onChange={() =>
                          handleToggle(codeType.id, "manually_add")
                        }
                        className="option-checkbox"
                        style={{ margin: 0 }}
                      />
                      <span
                        style={{
                          fontSize: "13px",
                          color: "#333131",
                          fontWeight: 500,
                        }}
                      >
                        Allow manual entry during product creation
                      </span>
                    </label>
                  </div>
                )}

                <Row>
                  {/* Left Column */}
                  <Col md={6}>
                    {/* Date */}
                    <div
                      className="option-group"
                      style={{
                        borderRadius: "8px",
                        padding: "5px 8px",
                        marginBottom: "4px",
                        transition: "background 0.15s",
                      }}
                    >
                      <label
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Form.Check
                          type="checkbox"
                          checked={settings[codeType.id].includeDate}
                          onChange={() =>
                            handleToggle(codeType.id, "includeDate")
                          }
                          className="option-checkbox"
                          style={{ margin: 0, marginRight: "0.5rem" }}
                        />
                        <span
                          style={{
                            fontSize: "12.5px",
                            color: settings[codeType.id].includeDate
                              ? "#4338ca"
                              : "#242425",
                            fontWeight: settings[codeType.id].includeDate
                              ? 500
                              : 400,
                          }}
                        >
                          Date
                        </span>
                      </label>
                      {settings[codeType.id].includeDate && (
                        <Form.Select
                          size="sm"
                          value={settings[codeType.id].dateFormat}
                          onChange={(e) =>
                            handleSelectChange(
                              codeType.id,
                              "dateFormat",
                              e.target.value,
                            )
                          }
                          style={{
                            marginTop: "6px",
                            border: "1.5px solid #e5e7eb",
                            borderRadius: "8px",
                            fontSize: "12px",
                            background: "#fafafa",
                          }}
                        >
                          {dateFormats.map((format) => (
                            <option key={format.value} value={format.value}>
                              {format.label}
                            </option>
                          ))}
                        </Form.Select>
                      )}
                    </div>

                    {/* Company Code */}
                    <div
                      className="option-group"
                      style={{
                        borderRadius: "8px",
                        padding: "5px 8px",
                        marginBottom: "4px",
                        transition: "background 0.15s",
                      }}
                    >
                      <label
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Form.Check
                          type="checkbox"
                          checked={settings[codeType.id].includeCompanyCode}
                          onChange={() =>
                            handleToggle(codeType.id, "includeCompanyCode")
                          }
                          className="option-checkbox"
                          style={{ margin: 0, marginRight: "0.5rem" }}
                        />
                        <span
                          style={{
                            fontSize: "12.5px",
                            color: settings[codeType.id].includeCompanyCode
                              ? "#4338ca"
                              : "#242425",
                            fontWeight: settings[codeType.id].includeCompanyCode
                              ? 500
                              : 400,
                          }}
                        >
                          Company Code
                        </span>
                      </label>
                    </div>

                    {/* Random Number */}
                    <div
                      className="option-group"
                      style={{
                        borderRadius: "8px",
                        padding: "5px 8px",
                        marginBottom: "4px",
                        transition: "background 0.15s",
                      }}
                    >
                      <label
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Form.Check
                          type="checkbox"
                          checked={settings[codeType.id].includeRandomNumber}
                          onChange={() =>
                            handleToggle(codeType.id, "includeRandomNumber")
                          }
                          className="option-checkbox"
                          style={{ margin: 0, marginRight: "0.5rem" }}
                        />
                        <span
                          style={{
                            fontSize: "12.5px",
                            color: settings[codeType.id].includeRandomNumber
                              ? "#4338ca"
                              : "#242425",
                            fontWeight: settings[codeType.id]
                              .includeRandomNumber
                              ? 500
                              : 400,
                          }}
                        >
                          Random Number
                        </span>
                      </label>
                      {settings[codeType.id].includeRandomNumber && (
                        <Form.Select
                          size="sm"
                          value={String(settings[codeType.id].randomDigits)}
                          onChange={(e) =>
                            handleSelectChange(
                              codeType.id,
                              "randomDigits",
                              parseInt(e.target.value),
                            )
                          }
                          style={{
                            marginTop: "6px",
                            border: "1.5px solid #e5e7eb",
                            borderRadius: "8px",
                            fontSize: "12px",
                            background: "#fafafa",
                          }}
                        >
                          {[3, 4].map((num) => (
                            <option key={num} value={String(num)}>
                              {num} digits
                            </option>
                          ))}
                        </Form.Select>
                      )}
                    </div>

                    {/* Indexing */}
                    <div
                      className="option-group"
                      style={{
                        borderRadius: "8px",
                        padding: "5px 8px",
                        marginBottom: "4px",
                        transition: "background 0.15s",
                      }}
                    >
                      <label
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Form.Check
                          type="checkbox"
                          checked={settings[codeType.id].includeIndexing}
                          onChange={() =>
                            handleToggle(codeType.id, "includeIndexing")
                          }
                          className="option-checkbox"
                          style={{ margin: 0, marginRight: "0.5rem" }}
                        />
                        <span
                          style={{
                            fontSize: "12.5px",
                            color: settings[codeType.id].includeIndexing
                              ? "#4338ca"
                              : "#242425",
                            fontWeight: settings[codeType.id].includeIndexing
                              ? 500
                              : 400,
                          }}
                        >
                          Indexing (0001, 0002, ...)
                        </span>
                      </label>

                      {/* Indexing Digits and Start Number Controls */}
                      {settings[codeType.id].includeIndexing && (
                        <div style={{ marginTop: "8px", paddingLeft: "24px" }}>
                          <div style={{ marginBottom: "8px" }}>
                            <label style={{ fontSize: "12px", color: "#666", fontWeight: 500 }}>
                              Number of Digits:
                            </label>
                            <Form.Select
                              size="sm"
                              value={settings[codeType.id].indexingDigits || 4}
                              onChange={(e) =>
                                handleSelectChange(codeType.id, "indexingDigits", parseInt(e.target.value))
                              }
                              style={{ marginTop: "4px" }}
                            >
                              <option value="1">1 digit — 1</option>
                              <option value="2">2 digits — 01</option>
                              <option value="3">3 digits — 001</option>
                              <option value="4">4 digits — 0001</option>
                              <option value="5">5 digits — 00001</option>
                              <option value="6">6 digits — 000001</option>
                            </Form.Select>
                          </div>

                          <div>
                            <label style={{ fontSize: "12px", color: "#666", fontWeight: 500 }}>
                              Starting Number:
                            </label>
                            <Form.Control
                              type="number"
                              min="1"
                              step="1"
                              size="sm"
                              value={settings[codeType.id].indexingStartNumber || 1}
                              onChange={(e) =>
                                handleSelectChange(codeType.id, "indexingStartNumber", parseInt(e.target.value) || 1)
                              }
                              style={{ marginTop: "4px" }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>

                  {/* Right Column */}
                  <Col md={6}>
                    {/* Customer ID */}
                    {settings[codeType.id].includeCustomerID !== undefined && (
                      <div
                        className="option-group"
                        style={{
                          borderRadius: "8px",
                          padding: "5px 8px",
                          marginBottom: "4px",
                          transition: "background 0.15s",
                        }}
                      >
                        <label
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Form.Check
                            type="checkbox"
                            checked={
                              settings[codeType.id].includeCustomerID || false
                            }
                            onChange={() =>
                              handleToggle(codeType.id, "includeCustomerID")
                            }
                            className="option-checkbox"
                            style={{ margin: 0, marginRight: "0.5rem" }}
                          />
                          <span
                            style={{
                              fontSize: "12.5px",
                              color: settings[codeType.id].includeCustomerID
                                ? "#4338ca"
                                : "#242425",
                              fontWeight: settings[codeType.id]
                                .includeCustomerID
                                ? 500
                                : 400,
                            }}
                          >
                            Customer ID
                          </span>
                        </label>
                      </div>
                    )}

                    {/* Variant ID */}
                    {settings[codeType.id].includeVariantID !== undefined && (
                      <div
                        className="option-group"
                        style={{
                          borderRadius: "8px",
                          padding: "5px 8px",
                          marginBottom: "4px",
                          transition: "background 0.15s",
                        }}
                      >
                        <label
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Form.Check
                            type="checkbox"
                            checked={
                              settings[codeType.id].includeVariantID || false
                            }
                            onChange={() =>
                              handleToggle(codeType.id, "includeVariantID")
                            }
                            className="option-checkbox"
                            style={{ margin: 0, marginRight: "0.5rem" }}
                          />
                          <span
                            style={{
                              fontSize: "12.5px",
                              color: settings[codeType.id].includeVariantID
                                ? "#4338ca"
                                : "#242425",
                              fontWeight: settings[codeType.id].includeVariantID
                                ? 500
                                : 400,
                            }}
                          >
                            Variant ID
                          </span>
                        </label>
                      </div>
                    )}

                    {/* Supplier ID */}
                    {settings[codeType.id].includeSupplierID !== undefined && (
                      <div
                        className="option-group"
                        style={{
                          borderRadius: "8px",
                          padding: "5px 8px",
                          marginBottom: "4px",
                          transition: "background 0.15s",
                        }}
                      >
                        <label
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Form.Check
                            type="checkbox"
                            checked={
                              settings[codeType.id].includeSupplierID || false
                            }
                            onChange={() =>
                              handleToggle(codeType.id, "includeSupplierID")
                            }
                            className="option-checkbox"
                            style={{ margin: 0, marginRight: "0.5rem" }}
                          />
                          <span
                            style={{
                              fontSize: "12.5px",
                              color: settings[codeType.id].includeSupplierID
                                ? "#4338ca"
                                : "#242425",
                              fontWeight: settings[codeType.id]
                                .includeSupplierID
                                ? 500
                                : 400,
                            }}
                          >
                            Supplier ID
                          </span>
                        </label>
                      </div>
                    )}

                    {/* Customized Text */}
                    <div
                      className="option-group"
                      style={{
                        borderRadius: "8px",
                        padding: "5px 8px",
                        marginBottom: "4px",
                        transition: "background 0.15s",
                      }}
                    >
                      <label
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Form.Check
                          type="checkbox"
                          checked={settings[codeType.id].includeCustomizedText}
                          onChange={() =>
                            handleToggle(codeType.id, "includeCustomizedText")
                          }
                          className="option-checkbox"
                          style={{ margin: 0, marginRight: "0.5rem" }}
                        />
                        <span
                          style={{
                            fontSize: "12.5px",
                            color: settings[codeType.id].includeCustomizedText
                              ? "#4338ca"
                              : "#242425",
                            fontWeight: settings[codeType.id]
                              .includeCustomizedText
                              ? 500
                              : 400,
                          }}
                        >
                          Customized Text
                        </span>
                      </label>
                      {settings[codeType.id].includeCustomizedText && (
                        <Form.Control
                          type="text"
                          size="sm"
                          placeholder="Enter text (max 5 chars)"
                          value={settings[codeType.id].customizedText}
                          onChange={(e) =>
                            handleTextChange(codeType.id, e.target.value)
                          }
                          maxLength="5"
                          style={{
                            marginTop: "6px",
                            border: "1.5px solid #e5e7eb",
                            borderRadius: "8px",
                            fontSize: "12px",
                            fontWeight: 600,
                            background: "#fafafa",
                          }}
                          onFocus={(e) =>
                            (e.target.style.border = "1.5px solid #6366f1")
                          }
                          onBlur={(e) =>
                            (e.target.style.border = "1.5px solid #e5e7eb")
                          }
                        />
                      )}
                    </div>
                  </Col>
                </Row>

                {/* Separator */}
                <div
                  style={{
                    borderTop: "1px solid #f0f2f5",
                    margin: "14px 0",
                    paddingTop: "14px",
                  }}
                >
                  <p
                    style={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: "0.8px",
                      margin: "0 0 8px",
                    }}
                  >
                    Separator
                  </p>
                  <Form.Select
                    size="sm"
                    value={settings[codeType.id].separator}
                    onChange={(e) =>
                      handleSelectChange(
                        codeType.id,
                        "separator",
                        e.target.value,
                      )
                    }
                    style={{
                      border: "1.5px solid #e5e7eb",
                      borderRadius: "8px",
                      fontSize: "13px",
                      color: "#374151",
                      background: "#fafafa",
                    }}
                  >
                    {separators.map((sep) => (
                      <option key={sep.value} value={sep.value}>
                        {sep.label}
                      </option>
                    ))}
                  </Form.Select>
                </div>

                {/* Drag to reorder */}
                <div
                  style={{
                    borderTop: "1px solid #f0f2f5",
                    margin: "14px 0",
                    paddingTop: "14px",
                  }}
                >
                  <p
                    style={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: "0.8px",
                      margin: "0 0 8px",
                    }}
                  >
                    Drag to Reorder Code Structure
                  </p>
                  {selectedItems.length === 0 ? (
                    <div
                      style={{
                        background: "#f8faff",
                        border: "1.5px dashed #c7d2fe",
                        borderRadius: "8px",
                        padding: "10px",
                        textAlign: "center",
                      }}
                    >
                      <small style={{ color: "#a5b4fc", fontSize: "12px" }}>
                        Enable options above to arrange order
                      </small>
                    </div>
                  ) : (
                    <div
                      className="order-boxes"
                      style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}
                    >
                      {selectedItems.map((item) => (
                        <OrderBox
                          key={item}
                          item={item}
                          codeType={codeType.id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                            padding: "5px 10px",
                            borderRadius: "8px",
                            fontSize: "12px",
                            fontWeight: 500,
                            background: "#f3f4f6",
                            border: "1.5px solid transparent",
                            color: "#374151",
                            cursor: "grab",
                            userSelect: "none",
                          }}
                        />
                      ))}
                    </div>
                  )}
                </div>

                {/* Preview */}
                <div
                  style={{
                    background: "#f8faff",
                    border: "1.5px dashed #c7d2fe",
                    borderRadius: "10px",
                    padding: "14px 16px",
                    marginBottom: "16px",
                  }}
                >
                  <p
                    style={{
                      fontSize: "10px",
                      fontWeight: 600,
                      color: "#a5b4fc",
                      textTransform: "uppercase",
                      letterSpacing: "0.8px",
                      margin: "0 0 6px",
                    }}
                  >
                    Preview
                  </p>
                  <code
                    style={{
                      display: "block",
                      textAlign: "center",
                      fontFamily: "'JetBrains Mono', 'Courier New', monospace",
                      fontSize: "1.2rem",
                      fontWeight: 700,
                      color: "#4f46e5",
                      letterSpacing: "1px",
                      wordBreak: "break-all",
                    }}
                  >
                    {generatePreview(codeType.id)}
                  </code>
                </div>

                {/* Save Button */}
                <Button
                  className="code-save-btn w-100"
                  onClick={() => handleSaveSettings(codeType.id)}
                  disabled={loadingStates[codeType.id]}
                  style={{
                    background:
                      "linear-gradient(135deg, #1b8d1b 0%, #1c7514 100%)",
                    border: "none",
                    borderRadius: "10px",
                    padding: "11px",
                    fontWeight: 600,
                    fontSize: "13.5px",
                    letterSpacing: "0.3px",
                    boxShadow: "0 2px 8px rgba(99,102,241,0.3)",
                    transition: "opacity 0.2s",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.9")}
                  onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
                >
                  {loadingStates[codeType.id] ? "Saving..." : "Save"}
                </Button>
              </Card.Body>
            </Card>
          </Col>
        );
        })}
      </Row>
      <SuccessModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        title={modalTitle}
        message={modalMessage}
        variant={modalVariant}
      />
    </div>
  );
}
